/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateTemplateV2Request extends models.TemplateV2Base {
    getFixupPrototypeFunction() { return CreateTemplateV2Request.fixupPrototype; }

    static newInstance(model: Partial<CreateTemplateV2Request>): CreateTemplateV2Request {
        let obj = Object.assign(new CreateTemplateV2Request(), model);
        CreateTemplateV2Request.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateTemplateV2Request>): CreateTemplateV2Request {
        if (!model) return null;
        return CreateTemplateV2Request.newInstance(<CreateTemplateV2Request> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateTemplateV2Request) {
        if (!obj) return;

        models.CreateTemplateV2Request.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateTemplateV2Request): boolean {
        if (models.TemplateV2Base.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CreateTemplateV2Request.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

}
